import "../../css/pages/executiveLeadership.scss";

import BasePage from "./base";
import leader from "../modules/leader";

class ExecutiveLeadershipPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
        leader.init();
    }
}

new ExecutiveLeadershipPage();
